'use client';

import React from 'react';
import { usePageVisibility } from 'react-page-visibility';
import { NUKI_SESSION_COOKIE_NAME, USER_META_CURRENT_COOKIE_NAME } from '@/utils/constants';

export function PageVisibilityCookieHandler() {
  const isPagevisible = usePageVisibility();

  const getCookieValue = (name: string): string => {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? match[2] : '';
  };

  // Remove stale host-only umc cookie (without domain) that was previously created by this handler.
  // Setting max-age=0 without a domain attribute targets the host-only copy and expires it.
  React.useEffect(() => {
    document.cookie = `${USER_META_CURRENT_COOKIE_NAME}=; max-age=0; path=/; SameSite=None; Secure`;
  }, []);

  React.useEffect(() => {
    if (isPagevisible) {
      document.cookie = `${USER_META_CURRENT_COOKIE_NAME}=${getCookieValue(USER_META_CURRENT_COOKIE_NAME)}; path=/; domain=.nuki.io; SameSite=None; Secure`;
      document.cookie = `${NUKI_SESSION_COOKIE_NAME}=${getCookieValue(NUKI_SESSION_COOKIE_NAME)}; path=/; SameSite=None; Secure`;
    } else {
      const maxAge = 60 * 60 * 3; // 3 hours in seconds
      document.cookie = `${USER_META_CURRENT_COOKIE_NAME}=${getCookieValue(USER_META_CURRENT_COOKIE_NAME)}; max-age=${maxAge}; path=/; domain=.nuki.io; SameSite=None; Secure`;
      document.cookie = `${NUKI_SESSION_COOKIE_NAME}=${getCookieValue(NUKI_SESSION_COOKIE_NAME)}; max-age=${maxAge}; path=/; SameSite=None; Secure`;
    }
  }, [isPagevisible]);

  return null;
}
